import { useEffect, useState } from "react";
import { categories, site } from "@/mocks/chigua";

const nav = [
  { label: "赛制总览", href: "#about" },
  { label: "参赛名单", href: "#roster" },
  { label: "种子选手", href: "#seeds" },
  { label: "热门瓜料", href: "#hot" },
  { label: "常见问题", href: "#faq" },
  { label: "提交瓜料", href: "#join" },
];

export default function Footer() {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 640);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <footer className="relative border-t border-background-300 bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl" />
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">
                {site.brand}
              </span>
            </a>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              {site.org}发起的年度网络热点盘点盛事，认真盘点、热闹围观，让每一颗好瓜都不被埋没。
            </p>
            <div className="mt-4 flex gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 ring-1 ring-background-300">
                <i className="ri-mic-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 ring-1 ring-background-300">
                <i className="ri-heart-3-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 ring-1 ring-background-300">
                <i className="ri-fire-line" />
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-950">快速导航</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {nav.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-950">晋级赛区</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {categories.map((c) => (
                <li key={c.id}>
                  <a href="#roster" className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    <i className={`${c.icon} text-primary-500`} />
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-600" />
                <a href={`mailto:${site.email}`}>{site.email}</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-chat-3-line text-primary-600" />
                {site.wechat}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-600" />
                工作日 10:00 — 19:00 在线
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-300 pt-6">
          <p className="text-xs leading-6 text-foreground-500">
            免责声明：本站榜单基于公开信息与网络公开讨论整理而成，所涉及事件、人物与机构设定仅用于本站内容盘点展示，不构成对任何真实个人、品牌或机构事实与资质的评价、背书或认证；资料信息请以官方渠道为准。转载或引用本站内容请注明出处。
          </p>
          <div className="mt-4 flex flex-col justify-between gap-2 text-xs text-foreground-500 sm:flex-row">
            <p>
              © {new Date().getFullYear()} {site.org} · {site.brand} All Rights Reserved.
            </p>
            <p className="inline-flex items-center gap-1.5">
              认真吃瓜 · 理性围观
              <i className="ri-water-flash-fill text-primary-500" />
            </p>
          </div>
        </div>
      </div>

      <a
        href="#top"
        aria-label="回到顶部"
        className={`fixed bottom-6 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all hover:bg-primary-600 md:right-8 ${
          showTop ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line text-xl" />
      </a>
    </footer>
  );
}